import { useMutation } from '@tanstack/react-query';

import { post } from '@front/common/src/api/requester';
import { ApiData } from '@front/common/src/types/commons';

import { SignupAccount, SignupResponse } from '../types/pro';

const validateUniqueSirenApi = {
  post: ({ siren }: { siren: string }) =>
    post('/pro/account/validate_siren', {
      body: {
        siren,
      },
    }),
};

const validateUniqueUserApi = {
  post: ({ email, phone }: { email?: string; phone?: string }) =>
    post('/pro/account/validate_unique', {
      body: {
        email,
        phone,
      },
    }),
};

type UseValidateUniqueUserBody = {
  email?: string;
  phone?: string;
};

export const useValidateUniqueUser = () => {
  const {
    mutate: validateUniqueUser,
    isLoading: isValidatingUserUnique,
    error: validateUniqueUserError,
  } = useMutation<ApiData<{}>, string[], UseValidateUniqueUserBody>({ mutationFn: validateUniqueUserApi.post });

  return { validateUniqueUser, isValidatingUserUnique, validateUniqueUserError };
};

type UseValidateUniqueSirenBody = {
  siren: string;
};

export const useValidateUniqueSiren = () => {
  const {
    mutate: validateUniqueSiren,
    isLoading: isValidatingSiren,
    error: validateSirenError,
  } = useMutation<ApiData<{}>, Error, UseValidateUniqueSirenBody>({
    mutationFn: (body: UseValidateUniqueSirenBody) => validateUniqueSirenApi.post(body),
  });

  return { validateUniqueSiren, isValidatingSiren, validateSirenError };
};

type UseCreateAccountParams = {
  body: SignupAccount;
  search?: string;
};
export const useCreateAccount = () =>
  useMutation<SignupResponse, Error, UseCreateAccountParams>({
    mutationFn: ({ body, search }: UseCreateAccountParams) => post('/pro/account', { body, search }),
  });
